import React from 'react';
import { Link } from 'react-router-dom';
import './ProofOfGoldAudit.css';

const ProofOfGoldAudit = () => {
  return (
    <main className="proof-audit-wrapper">
      <section className="bg-primary-light mt-5 gold_pattern px-80 py-5">
        <div className="container mt-5">
          <div className="row justify-content-center mb-5 pb-5">
            <div className="col-lg-9">
              <div className="z-index-3 text-center">
                <h2 className="main-title mb-4 w-100">Gold Reserves</h2>
                <p className="fs-18 m-0" style={{ color: 'var(--cgo-text)', textAlign: 'center' }}>
                  Every ComTech Gold token (CGO) is backed 1:1 by one gram of physical 999.9 and 999.5
                  purity gold held in regulated, insured vaults. This page provides real-time and audited proof of
                  our gold reserves, custody arrangements, and token supply — so you can verify our backing at
                  any time.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-secondary-light px-80 py-5">
        <div className="container">
          {/* Live Reserve Dashboard */}
          <div className="row justify-content-center mb-5">
            {/* <div className="col-lg-11">
              <h3 className="h3 text-primary mb-4">1. Live Reserve Dashboard</h3>
              <div className="row text-center g-4 justify-content-center">
                <div className="col-md-4">
                  <div className="reserve-card shadow-sm">
                    <h3 className="reserve-value text-primary">3,000</h3>
                    <p className="reserve-label" style={{ color: 'var(--cgo-text-muted)' }}>Digital Gold</p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="reserve-card shadow-sm">
                    <h3 className="reserve-value text-primary">44,000</h3>
                    <p className="reserve-label" style={{ color: 'var(--cgo-text-muted)' }}>Tokenized Gold</p>
                  </div>
                </div>
              </div>
            </div> */}
          </div>

          {/* 2. Custody Details */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-11">
              <h3 className="h3 text-primary mt-4 mb-4">2. Custody Details</h3>
              <div className="custom-table-container shadow-sm">
                <table className="custom-table">
                  <thead>
                    <tr>
                      <th scope="col" style={{ width: '35%', backgroundColor: 'var(--cgo-table-head-bg)', color: 'var(--cgo-table-head-fg)' }}>Item</th>
                      <th scope="col" style={{ backgroundColor: 'var(--cgo-table-head-bg)', color: 'var(--cgo-table-head-fg)' }}>Detail</th>
                    </tr>
                  </thead>
                  <tbody style={{ color: 'var(--cgo-text)' }}>
                    <tr>
                      <td className="fw-bold">Primary Vault Custodian</td>
                      <td>TransGuard Group (Emirates Group Company), Dubai, UAE</td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Digital Asset Custodian</td>
                      <td>BitGo — Institutional-grade qualified custodian</td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Gold Purity</td>
                      <td>999.9 and 999.5 fineness, 24 Karat (LBMA standard)</td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Vault Location</td>
                      <td>UAE (specific location disclosed to auditors and regulators)</td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Government Oversight</td>
                      <td>DMCC (Dubai Multi Commodities Centre) endorses all gold movements</td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Insurance</td>
                      <td>Comprehensive global vault insurance held by TransGuard Group</td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Segregation</td>
                      <td>Gold is held in accounts segregated from ComTech Gold's corporate assets</td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Bar References</td>
                      <td>[Tradeflow warrant references available to verified institutional partners]</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Document Downloads */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-11">
              <h3 className="h3 text-primary mt-4 mb-4">3. Document Downloads</h3>
              <p className="mb-4 fs-18" style={{ color: 'var(--cgo-text)' }}>Access official documentation and compliance reports:</p>
              <div className="custom-table-container shadow-sm">
                <table className="custom-table">
                  <thead>
                    <tr>
                      <th scope="col" style={{ width: '40%', backgroundColor: 'var(--cgo-table-head-bg)', color: 'var(--cgo-table-head-fg)' }}>Document</th>
                      <th scope="col" style={{ backgroundColor: 'var(--cgo-table-head-bg)', color: 'var(--cgo-table-head-fg)' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody style={{ color: 'var(--cgo-text)' }}>
                    <tr>
                      <td className="fw-bold">CGO Whitepaper</td>
                      <td>
                        <Link to="/assets/pdf/cgo_whitepaper_v1.pdf" target="_blank" className="download-action" style={{ color: 'var(--cgo-accent)', fontWeight: 'bold' }}>
                          View Document
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Terms of Use</td>
                      <td>
                        <Link to="/assets/pdf/Terms_and_Conditions.pdf" className="download-action" download target='_blank' style={{ color: 'var(--cgo-accent)', fontWeight: 'bold' }}>
                          Download PDF
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Custody Agreement Summary</td>
                      <td style={{ color: 'var(--cgo-text-muted)' }}>Coming Soon</td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Redemption Terms</td>
                      <td style={{ color: 'var(--cgo-text-muted)' }}>Coming Soon</td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Latest Audit Report</td>
                      <td><Link to="/Routine" style={{ color: 'var(--cgo-accent)', fontWeight: 'bold' }}>View Audits</Link></td>
                    </tr>
                    <tr>
                      <td className="fw-bold">Shariah Certification (Fatwa)</td>
                      <td>
                         <Link to="/assets/pdf/ComTech_Gold_Token_Shariah_Compliance_Cert.pdf" className="download-action" download target='_blank' style={{ color: 'var(--cgo-accent)', fontWeight: 'bold' }}>
                          View Certificate
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td className="fw-bold">AML & Compliance Policy Summary</td>
                      <td>
                        <Link to="/assets/pdf/Compliance&AMLPolicy.pdf" className="download-action" download target='_blank' style={{ color: 'var(--cgo-accent)', fontWeight: 'bold' }}>
                          View Policy
                        </Link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ProofOfGoldAudit;
